export const init = () => {
  const getPardotIframes = () =>
    [...document.querySelectorAll("iframe")].filter((iframe) =>
      iframe.src.match(/^https:\/\/info\.iqmetrix\.com/)
    );

  const escapeRegExp = (text: string) =>
    text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");

  getPardotIframes()
    .filter(
      (iframe) =>
        !iframe.src.match(
          new RegExp(escapeRegExp(window.location.search) + "$")
        )
    )
    .forEach((iframe) => (iframe.src += window.location.search));
};

export default init();
